module.exports = __webpack_public_path__ + "static/media/checkbox-checked-32.3e3973a3.svg";